import httpClientFactory from './httpClientFactory';
import { useRouter } from 'vue-router';
import { getAcessToken } from '@/modules/shared/storage';
import { i18n } from '@/modules/localization';
import { ref, computed } from 'vue';

export default async(error) => {
  const router = useRouter();
  try {
    const httpClient = httpClientFactory();
    if (localStorage.getItem('access_token')) {
      const refreshToken = localStorage.getItem('refresh_token');
      const response = await httpClient.post('refreshToken', { refreshToken });
      localStorage.setItem('access_token', response.data.token);
      localStorage.setItem('refresh_token', response.data.refreshToken);
    } else {
      const refreshToken = sessionStorage.getItem('refresh_token');
      const response = await httpClient.post('refreshToken', { refreshToken });
      sessionStorage.setItem('access_token', response.data.token);
      sessionStorage.setItem('refresh_token', response.data.refreshToken);
    }
  } catch (e) {
    router.push({ path: '/logout', query: { redirect: router.currentRoute.path } }).catch(() => { });
    throw new Error(ref(computed((_) => i18n.global.t('suaSessaoExpirou'))));
  }

  return repeatLastRequest(error);
};

const repeatLastRequest = async(error) => {
  const originalRequest = error.config;
  const httpClient = httpClientFactory();
  originalRequest.headers.Authorization = `bearer ${getAcessToken()}`;
  return await httpClient.request(originalRequest);
};
